import { Injectable } from '@angular/core';
import { Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable()
export class MetaDescriptionService {
    constructor(private metaService: Meta) {}

    public addMetaDescriptionTag = (metaDescription: string): void => {
        const description: MetaDefinition = {
            name: 'description',
            content: metaDescription
        };
        this.metaService.addTag(description);
    }

    public removeMetaDescriptionTag = (): void => {
        this.metaService.removeTag('name=\'description\'');
    }
}
